import { useCallback, useState } from 'react';
import { request } from '../common/request';

export interface IProfile {
  name: string;
  email: string;
  ethereumAddress: string;
}

export function useProfile() {
  const [profile, setProfile] = useState<IProfile>();

  const getProfile = useCallback(() => {
    request.get<{ data: IProfile }>('/users/me')
      .then(response => setProfile(response.data.data))
      .catch(() => { })
  }, []);

  return { profile, getProfile };
}